// extracted by mini-css-extract-plugin
module.exports = {"item":"L_c6","item__image":"L_c7"};